<template>
  <div class="App-address-select">
    <label class="address-select-label">
      {{ label }}
    </label>
    <div class="App-radio__item" v-for="(val, key) in addresses" :key="val">
      <label class="mdl-radio mdl-js-radio" :for="'addr' + key">
        <input
          class="mdl-radio__button"
          :id="'addr' + key"
          name="addr"
          type="radio"
          :value="val"
          @click="setOwnershipAddress(val)"
          :checked="ownership.address === val"
        />
        <span class="mdl-radio__label App-mdl-radio__label">{{ val }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  props: ['addresses', 'label'],
  computed: {
    ...mapGetters({
      ownership: 'ownership/ownership'
    })
  },
  mounted() {
    componentHandler.upgradeAllRegistered();
  },
  methods: {
    ...mapActions('ownership', ['setOwnershipAddress'])
  }
};
</script>

<style scoped>
.App-radio__item {
  margin-top: 5px;
  margin-top: 5px;
}

.App-mdl-radio__label {
  font-size: 16px;
}

.App-address-select {
  padding-top: 0px;
  padding-bottom: 20px;
}

.address-select-label {
  color: rgb(63, 81, 181);
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Ownership/AddressSelect.vue